import React, { useMemo, useState } from "react";
import { useParams } from "react-router-dom";
import Loader from "../../../components/Loader";
import InnerBannerBreadcrumb from "../../../components/shared/breadcrumb/InnerBannerBreadcrumb";
import {
  convertStringToArray,
  extractDate,
  sanitizeString,
} from "../../../Utils/utils";
import { useSelector } from "react-redux";
import { useLanguageTranslation } from "../../../hooks/useLanguageTranslation";
import { useGetProtectedApiDataQuery } from "../../../redux/services/apiSlice";
import PageLastUpdated from "../../../components/shared/PageLastUpdated";
import ShowTable from "../../../components/ShowTable";

import EventCard from "./EventCard";

const EventsDetailById = () => {
  const { languageType } = useSelector((state) => state.homeSlice);

  const { getText } = useLanguageTranslation();
  const { id } = useParams();
  const {
    data: eventsData = [],
    error,
    isLoading: eventsIsLoading,
  } = useGetProtectedApiDataQuery({ url: "event", lang: languageType });

  const transformedData = useMemo(() => {
    return eventsData.map((item) => ({
      ...item,
      field_upload_image: convertStringToArray(item.field_upload_image),
    }));
  }, [eventsData]);

  const selectedEvent = transformedData.find((event) => event.nid === id);

  const selectedTitle = sanitizeString(selectedEvent?.title);
  const selectedDescription = sanitizeString(selectedEvent?.body);

  const modifiedObj = {
    ...selectedEvent,
    field_download: convertStringToArray(selectedEvent?.field_download),
  };

  const file_ext = modifiedObj.field_video?.slice(-3);

  const lastUpdatedOn = useMemo(() => {
    return extractDate(selectedEvent);
  }, [selectedEvent]);

  if (error) {
    return <p>Error: {error.message}</p>;
  }

  if (eventsIsLoading) {
    return <Loader />;
  }

  return (
    <>
      <InnerBannerBreadcrumb
        bannerImage="/images/inner_aboutbann.jpg"
        title={getText("Events", "गतिविधियाँ")}
        titleLink="/events-detail"
        titleTwo={selectedTitle}
        levelTwo={true}
        levelThree={false}
        isActive={selectedTitle}
      />
      <div className="inner-container">
        <div className="container">
          <section className="news-detail">
            <div className="container">
              <PageLastUpdated lastUpdatedOn={lastUpdatedOn} />
              {selectedEvent ? (
                <>
                  <div className="row mb-5">
                    <div className="col-12 col-sm-12 col-md-3 col-lg-3">
                      <EventCard selectedEvent={selectedEvent} />
                    </div>
                    <div className="col-12 col-sm-12 col-md-9 col-lg-9">
                      <div className="title-sec">
                        <h4>{selectedTitle}</h4>
                      </div>

                      <div className="about_inntxt desc-sec">
                        {selectedEvent.field_ordering_date && (
                          <span className="date">
                            <b>Date: {selectedEvent.field_ordering_date}</b>
                          </span>
                        )}
                        <div>{selectedDescription}</div>
                      </div>
                    </div>
                    {/* video */}
                    {modifiedObj.field_video && file_ext === "mp4" ? (
                      <>
                        <div className="title4">
                          <h4>Video</h4>
                        </div>
                        <video controls>
                          <source
                            src={`${process.env.REACT_APP_IMAGE_URL}/neepco/sites/default/files/2024-07/${selectedEvent.field_video}`}
                            type="audio/mpeg"
                          />
                        </video>
                      </>
                    ) : modifiedObj.field_video && file_ext === "mp3" ? (
                      <>
                        <div className="title4">
                          <h4>Audio</h4>
                        </div>
                        <audio controls>
                          <source
                            src={`${process.env.REACT_APP_IMAGE_URL}/neepco/sites/default/files/2024-07/${selectedEvent.field_video}`}
                            type="audio/mpeg"
                          />
                        </audio>
                      </>
                    ) : (
                      <></>
                    )}
                    {/* table data */}
                    {/* <ShowTable data={modifiedObj.field_download} /> */}
                  </div>
                </>
              ) : (
                <>
                  <p>event with id {id} not found</p>
                </>
              )}
            </div>
          </section>
        </div>
      </div>
    </>
  );
};

export default EventsDetailById;
